import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLID,
  GraphQLBoolean,
  GraphQLList
} from 'graphql';

import ChannelCardType from './channelCard.gql';
import Node from './node.gql.js';

const channelType = new GraphQLObjectType({
  name: 'Channel',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => item.id
    },
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    name: {
      type: GraphQLString,
      resolve: item => item.name
    },
    image: {
      type: GraphQLString,
      resolve: item => item.image
    },
    description: {
      type: GraphQLString,
      resolve: item => item.description
    },
    updatedAt: {
      type: GraphQLString,
      resolve: item => item.updatedAt
    },
    isFollowed: {
      type: GraphQLBoolean,
      resolve: item => item.isFollowed
    },
    approvedChannelCards: {
      type: new GraphQLList(ChannelCardType),
      resolve: item => item.approvedChannelCards
    },
    allChannelCards: {
      type: new GraphQLList(ChannelCardType),
      resolve: item => item.allChannelCards
    }
  }),
  interfaces: [Node.nodeInterface]
});

window[channelType.name + 'GQLType'] = channelType;

export default channelType;
